<template>
    <div>
        <v-container fluid v-resize="onResize">
            <!--Usd Quotes-->
            <v-row no-gutters>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <div
                        style="max-height: 600px; overflow-y: auto;"
                        class="mt-5 mx-3"
                    >
                        <v-data-table
                            class="ranges-table"
                            :headers="quotesByAgesHeaders"
                            :items="filteredQuotesByAgesUsd"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                            :mobile-breakpoint="0"
                            fixed-header
                        >
                            <template v-slot:top>
                                <v-toolbar
                                    flat
                                    no-gutters
                                    style="background-color: #eeeeee"
                                    :class="
                                        $vuetify.breakpoint.xs
                                            ? 'd-flex flex-column align-items-center py-4'
                                            : 'd-flex justify-between align-items-center py-4'
                                    "
                                >
                                    <v-toolbar-title
                                        >Quotes by Ages (USD)</v-toolbar-title
                                    >
                                </v-toolbar>
                            </template>
                            <template v-slot:[`header.name`]>
                                <v-text-field
                                    v-model="usdSearch"
                                    label="Clients"
                                    append-icon="mdi-magnify"
                                    hide-details
                                    single-line
                                    dense
                                />
                            </template>
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td style="width: 150px;">
                                        {{ item.name }}
                                    </td>
                                    <td
                                        v-for="(range,
                                        index) in quotesByAgesUSD[item.name]
                                            .ranges"
                                        :key="index"
                                        @click="
                                            openUsdRangeDialog(
                                                item.name,
                                                `${formatDate(
                                                    range.startDate
                                                )} - ${formatDate(
                                                    range.endDate
                                                )}`,
                                                `${range.from} days - ${range.to} days`
                                            )
                                        "
                                    >
                                        {{
                                            formatCurrency(
                                                'USD',
                                                getTotalCosts(range.usdQuotes)
                                            )
                                        }}
                                    </td>
                                    <td>
                                        {{ formatCurrency('USD', item.total) }}
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:[`body.append`]>
                                <tr style="background-color: #eeeeee;">
                                    <td><strong>Total</strong></td>
                                    <td
                                        v-for="(header,
                                        index) in quotesByAgesHeaders.slice(
                                            1,
                                            -1
                                        )"
                                        :key="index"
                                    >
                                        {{
                                            formatCurrency(
                                                'USD',
                                                getTotalsByRangeUsd(header.text)
                                            )
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            formatCurrency(
                                                'USD',
                                                getFilteredTotalCostsUsd(
                                                    'total'
                                                )
                                            )
                                        }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <div class="mt-5 mx-3">
                        <highcharts
                            :options="chartUsdQuotesByAges"
                        ></highcharts>
                    </div>
                </v-col>
            </v-row>
            <!--Cop Quotes-->
            <v-row no-gutters>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <div
                        class="mt-10 mx-3"
                        style="max-height: 600px; overflow-y: auto;"
                    >
                        <v-data-table
                            class="ranges-table"
                            :headers="quotesByAgesHeaders"
                            :items="filteredQuotesByAgesCop"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                            :mobile-breakpoint="0"
                            fixed-header
                        >
                            <template v-slot:top>
                                <v-toolbar
                                    flat
                                    no-gutters
                                    style="background-color: #eeeeee"
                                    :class="
                                        $vuetify.breakpoint.xs
                                            ? 'd-flex flex-column align-items-center py-4'
                                            : 'd-flex justify-between align-items-center py-4'
                                    "
                                >
                                    <v-toolbar-title
                                        >Quotes by Ages (COP)</v-toolbar-title
                                    >
                                </v-toolbar>
                            </template>
                            <template v-slot:[`header.name`]>
                                <v-text-field
                                    v-model="copSearch"
                                    label="Clients"
                                    append-icon="mdi-magnify"
                                    hide-details
                                    single-line
                                    dense
                                />
                            </template>
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td style="width: 150px;">
                                        {{ item.name }}
                                    </td>
                                    <td
                                        v-for="(range,
                                        index) in quotesByAgesCOP[item.name]
                                            .ranges"
                                        :key="index"
                                        @click="
                                            openCopRangeDialog(
                                                item.name,
                                                `${formatDate(
                                                    range.startDate
                                                )} - ${formatDate(
                                                    range.endDate
                                                )}`,
                                                `${range.from} days - ${range.to} days`
                                            )
                                        "
                                    >
                                        {{
                                            formatCurrency(
                                                'COP',
                                                getTotalCosts(range.copQuotes)
                                            )
                                        }}
                                    </td>
                                    <td>
                                        {{ formatCurrency('COP', item.total) }}
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:[`body.append`]>
                                <tr style="background-color: #eeeeee;">
                                    <td><strong>Total</strong></td>
                                    <td
                                        v-for="(header,
                                        index) in quotesByAgesHeaders.slice(
                                            1,
                                            -1
                                        )"
                                        :key="index"
                                    >
                                        {{
                                            formatCurrency(
                                                'COP',
                                                getTotalsByRangeCop(header.text)
                                            )
                                        }}
                                    </td>
                                    <td>
                                        {{
                                            formatCurrency(
                                                'COP',
                                                getFilteredTotalCostsCop(
                                                    'total'
                                                )
                                            )
                                        }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <div style="margin-top: 35px;">
                        <highcharts
                            :options="chartCopQuotesByAges"
                        ></highcharts>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <!-- Quotes Dialog -->
        <v-dialog
            v-model="quotesDialog"
            max-width="1500px"
            :retain-focus="false"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ headerRange }}
                </v-card-title>
                <v-card-text>
                    <p>{{ formattedRange }}</p>

                    <v-alert
                        v-if="
                            !quotesForSelectedRange ||
                                quotesForSelectedRange.length === 0
                        "
                        type="info"
                        class="mb-4"
                        outlined
                    >
                        There are no quotes available for this client in the
                        selected date range.
                    </v-alert>

                    <div style="max-height: 800px; overflow-y: auto;">
                        <v-data-table
                            :headers="headers"
                            :items="quotesForSelectedRange || []"
                            disable-pagination
                            hide-default-footer
                            :mobile-breakpoint="0"
                            class="mt-2 quotes-table"
                            @click:row="openQuote"
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="grey lighten-3">
                                    <v-toolbar-title>QUOTES</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:[`item.userId`]="{ item }">
                                <div>
                                    {{ getUserName(item.userId) }}
                                </div>
                            </template>

                            <template v-slot:[`item.totalCosts`]="{ item }">
                                <div>
                                    {{
                                        formatCurrency(
                                            quotesCurrency,
                                            +item.totalCosts
                                        )
                                    }}
                                </div>
                            </template>

                            <template v-slot:[`body.append`]>
                                <tr class="grey lighten-3 font-weight-bold">
                                    <td>
                                        <!-- Aquí iría "TOTALS" alineado con Price -->
                                        TOTALS
                                    </td>
                                    <td colspan="3"></td>
                                    <!-- Esto ocupa las primeras 4 columnas -->
                                    <td class="text-right">
                                        {{
                                            formatCurrency(
                                                quotesCurrency,
                                                getTotalCosts(
                                                    quotesForSelectedRange
                                                )
                                            )
                                        }}
                                    </td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeDialog"
                        class="mt-n3 mb-3"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Quote dialog -->
        <v-dialog
            :retain-focus="false"
            v-model="dialogQuote"
            fullscreen
            ref="dialogQuote"
        >
            <v-card v-if="dialogQuote" class="fill-height d-flex flex-column">
                <v-card-title class="ml-n4">
                    <v-btn icon @click="backToQuotesByAges">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    Quote
                </v-card-title>
                <v-card-text class="px-0 flex-grow-1" style="overflow-y: auto">
                    <Quote
                        :id="cardQuote.id"
                        :quote="cardQuote"
                        :settings="settings"
                        :followUp="true"
                        :history="false"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>

        <Errors />
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { Chart } from 'highcharts-vue'
import API from '@/services/api'
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'QuotesByAges',
    props: {
        quotes: {
            type: Array,
            default() {
                return []
            },
        },
        users: {
            type: Array,
            required: true,
        },
    },
    components: {
        highcharts: Chart,
        Quote: () => import('@/views/Quotes/Quote.vue'),
        Errors: () => import('@/components/Layout/Errors'),
    },
    data() {
        return {
            height: 0,
            heightPopUp: 0,
            quotesData: [],
            quotesByAges: {},
            quotesCurrency: '',
            quotesDialog: false,
            quotesUsdDialog: false,
            quotesCopDialog: false,
            selectedClientName: null,
            chartUsdQuotesByAges: {},
            chartCopQuotesByAges: {},
            quotesByAgesUSD: {},
            quotesByAgesCOP: {},
            usdSearch: '',
            copSearch: '',
            quoteRanges: [],
            quotesForSelectedRange: {},
            formattedRange: '',
            headerRange: '',
            ranges: [],
            quotesByAgesHeaders: this.generateHeaders(),
            dataCache: {
                lastCalculation: null,
                quotesHash: null,
                rangesHash: null,
            },
            rangeDataCache: {}, // Cache específico por rango y cliente
            headers: [
                {
                    text: 'ID',
                    value: 'number',
                    sortable: true,
                },
                {
                    text: 'Name',
                    value: 'name',
                    align: 'center',
                    sortable: true,
                },
                {
                    text: 'Client',
                    value: 'client.name',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'City',
                    value: 'city',
                    align: 'center',
                    sortable: true,
                },
                {
                    text: 'Price',
                    value: 'totalCosts',
                    align: 'end',
                    sortable: true,
                },
                {
                    text: 'Account Manager',
                    value: 'userId',
                    align: 'center',
                    sortable: false,
                },
            ],
            settingId: '',
            loading: false,
            dialogQuote: false,
        }
    },
    computed: {
        ...mapState(['costQuotes']),
        formattedQuotesByAgesUsd() {
            return Object.keys(this.quotesByAgesUSD).map(clientName => {
                const totals = {
                    name: clientName,
                    totalByRange: {},
                    total: 0,
                }

                const ranges = this.quotesByAgesUSD[clientName].ranges

                for (let i = 0; i < ranges.length; i++) {
                    const range = ranges[i]
                    const usdQuotesInRange = range.usdQuotes || []
                    const totalForRange = this.getTotalCosts(usdQuotesInRange)

                    const rangeLabel =
                        this.quotesByAgesHeaders[i + 1]?.text ||
                        `Range ${i + 1}`
                    totals.totalByRange[rangeLabel] = totalForRange

                    // Agregar propiedades para ordenamiento
                    const headerValue = this.quotesByAgesHeaders[i + 1]?.value
                    if (headerValue) {
                        totals[headerValue] = totalForRange
                    }

                    totals.total += totalForRange
                }
                return totals
            })
        },
        filteredQuotesByAgesUsd() {
            if (!this.usdSearch) {
                return this.formattedQuotesByAgesUsd
            }
            return this.formattedQuotesByAgesUsd.filter(quote =>
                quote.name.toLowerCase().includes(this.usdSearch.toLowerCase())
            )
        },
        formattedQuotesByAgesCop() {
            return Object.keys(this.quotesByAgesCOP).map(clientName => {
                const totals = {
                    name: clientName,
                    totalByRange: {},
                    total: 0,
                }

                const ranges = this.quotesByAgesCOP[clientName].ranges

                for (let i = 0; i < ranges.length; i++) {
                    const range = ranges[i]
                    const copQuotesInRange = range.copQuotes || []
                    const totalForRange = this.getTotalCosts(copQuotesInRange)

                    const rangeLabel =
                        this.quotesByAgesHeaders[i + 1]?.text ||
                        `Range ${i + 1}`
                    totals.totalByRange[rangeLabel] = totalForRange

                    // Agregar propiedades para ordenamiento
                    const headerValue = this.quotesByAgesHeaders[i + 1]?.value
                    if (headerValue) {
                        totals[headerValue] = totalForRange
                    }

                    totals.total += totalForRange
                }
                return totals
            })
        },
        filteredQuotesByAgesCop() {
            if (!this.copSearch) {
                return this.formattedQuotesByAgesCop
            }
            return this.formattedQuotesByAgesCop.filter(quote =>
                quote.name.toLowerCase().includes(this.copSearch.toLowerCase())
            )
        },
    },
    watch: {
        filteredQuotesByAgesUsd() {
            this.createUsdPieChart()
        },
        filteredQuotesByAgesCop() {
            this.createCopPieChart()
        },
        ranges() {
            this.filterByDateRange()
            this.quotesByAgesHeaders = this.generateHeaders()
        },
        quotesByAgesUSD: {
            handler(newVal) {
                // Limpiar datos del diálogo si los datos cambian
                if (this.quotesDialog && this.selectedClientName) {
                    if (!newVal || !newVal[this.selectedClientName]) {
                        this.closeDialog()
                    }
                }
            },
            deep: true,
        },
        quotesByAgesCOP: {
            handler(newVal) {
                // Limpiar datos del diálogo si los datos cambian
                if (this.quotesDialog && this.selectedClientName) {
                    if (!newVal || !newVal[this.selectedClientName]) {
                        this.closeDialog()
                    }
                }
            },
            deep: true,
        },
    },
    async mounted() {
        try {
            this.loading = true
            // get setting id
            const {
                data: { settings },
            } = await API.getSettings()

            this.settings = settings

            const settingIndex = settings.findIndex(u => u.name === 'Quotes')
            if (settingIndex > -1) {
                this.settingId = settings[settingIndex].id
            }

            this.filterByDateRange()
            // get quote ranges
            this.ranges = await this.fetchQuoteRanges()
            this.$nextTick(() => {
                this.onResize()
            })
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions([
            'addHistoryQuotesAction',
            'setFromMainBoardAction',
            'addHistoryCostAction',
        ]),
        async fetchQuoteRanges() {
            try {
                this.loading = true
                if (this.settingId) {
                    const response = await API.getQuoteRanges(this.settingId)
                    const quoteRangesArray = Array.isArray(
                        response.quoteRanges[0]
                    )
                        ? response.quoteRanges[0]
                        : response.quoteRanges
                    return quoteRangesArray.quoteRanges
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        generateHeaders() {
            const staticHeaders = [
                {
                    text: 'Clients',
                    value: 'name',
                    sortable: false,
                    align: 'rigth',
                },
            ]

            const dynamicHeaders = Array.isArray(this.ranges)
                ? this.ranges.map(range => {
                      return {
                          text: `${range.from} - ${range.to} days`,
                          value: `total${range.from}To${range.to}`,
                          sortable: true,
                      }
                  })
                : []

            return [
                ...staticHeaders,
                ...dynamicHeaders,
                { text: 'Total', value: 'total', sortable: true },
            ]
        },
        updateRanges(newRanges) {
            this.ranges = newRanges
            this.quotesByAgesHeaders = this.generateHeaders()
        },
        formatDate(date) {
            return date.toLocaleDateString()
        },
        getTotalsByRangeUsd(rangeLabel) {
            return this.filteredQuotesByAgesUsd.reduce((totalSum, client) => {
                return totalSum + (client.totalByRange[rangeLabel] || 0)
            }, 0)
        },
        getTotalsByRangeCop(rangeLabel) {
            return this.filteredQuotesByAgesCop.reduce((totalSum, client) => {
                return totalSum + (client.totalByRange[rangeLabel] || 0)
            }, 0)
        },
        getTotalCosts(quotes) {
            return quotes.reduce((total, quote) => {
                return +total + (+quote.totalCosts || 0)
            }, 0)
        },
        getFilteredTotalCostsUsd(key) {
            return this.filteredQuotesByAgesUsd.reduce(
                (sum, client) => sum + client[key],
                0
            )
        },
        getFilteredTotalCostsCop(key) {
            return this.filteredQuotesByAgesCop.reduce(
                (sum, client) => sum + client[key],
                0
            )
        },
        getUserName(id) {
            if (this.users.length > 0) {
                const userReference = this.users.find(user => user.id == id)
                if (userReference) {
                    return userReference.name
                } else {
                    return ''
                }
            } else {
                return ''
            }
        },
        formatCurrency(currency, value) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
            }).format(value)
        },
        generateDataHash() {
            const quotesHash = JSON.stringify(this.quotes)
            const rangesHash = JSON.stringify(this.ranges)
            return { quotesHash, rangesHash }
        },
        filterByDateRange() {
            // Verificar si necesitamos recalcular
            const { quotesHash, rangesHash } = this.generateDataHash()
            if (
                this.dataCache.quotesHash === quotesHash &&
                this.dataCache.rangesHash === rangesHash &&
                this.dataCache.lastCalculation
            ) {
                return {
                    usdQuotesByAges: this.quotesByAgesUSD,
                    copQuotesByAges: this.quotesByAgesCOP,
                }
            }

            // Limpiar datos del diálogo si está abierto
            if (this.quotesDialog) {
                this.closeDialog()
            }

            // Limpiar cache de rangos cuando se recalculan los datos
            this.rangeDataCache = {}

            this.quotesByAgesUSD = {}
            this.quotesByAgesCOP = {}
            const currentDate = new Date()
            const allQuotes = Object.values(this.quotes).flat()
            for (let quote of allQuotes) {
                if (quote.sentDate) {
                    if (this.ranges) {
                        const sentDate = new Date(
                            (quote.sentDate.seconds ||
                                quote.sentDate._seconds) * 1000
                        )
                        // set data ranges
                        this.quoteRanges = []
                        const ranges = Object.values(this.ranges)

                        for (let range of ranges) {
                            const startDate = new Date(currentDate)
                            startDate.setDate(currentDate.getDate() - range.to)

                            const endDate = new Date(currentDate)
                            endDate.setDate(currentDate.getDate() - range.from)

                            let quoteRange = {
                                startDate: startDate,
                                endDate: endDate,
                                from: range.from,
                                to: range.to,
                                usdQuotes: [],
                                copQuotes: [],
                            }
                            this.quoteRanges.push(quoteRange)
                        }

                        const clientName = quote.client?.name || ''

                        if (!this.quotesByAgesUSD[clientName]) {
                            this.quotesByAgesUSD[clientName] = {
                                ranges: this.quoteRanges.map(range => ({
                                    ...range,
                                    usdQuotes: [],
                                })),
                            }
                        }
                        if (!this.quotesByAgesCOP[clientName]) {
                            this.quotesByAgesCOP[clientName] = {
                                ranges: this.quoteRanges.map(range => ({
                                    ...range,
                                    copQuotes: [],
                                })),
                            }
                        }

                        // sort into range based on currency
                        for (let range of this.quoteRanges) {
                            if (
                                sentDate >= range.startDate &&
                                sentDate <= range.endDate
                            ) {
                                if (quote.currency == 'USD') {
                                    this.quotesByAgesUSD[clientName].ranges
                                        .find(
                                            r =>
                                                r.from === range.from &&
                                                r.to === range.to
                                        )
                                        .usdQuotes.push(quote)
                                } else if (quote.currency == 'COP') {
                                    this.quotesByAgesCOP[clientName].ranges
                                        .find(
                                            r =>
                                                r.from === range.from &&
                                                r.to === range.to
                                        )
                                        .copQuotes.push(quote)
                                }
                            }
                        }
                    }
                }
            }

            // delete clients without quotes in ranges
            this.quotesByAgesUSD = this._filterEmptyClients(
                this.quotesByAgesUSD,
                'usdQuotes'
            )
            this.quotesByAgesCOP = this._filterEmptyClients(
                this.quotesByAgesCOP,
                'copQuotes'
            )

            // Actualizar cache
            this.dataCache = {
                lastCalculation: Date.now(),
                quotesHash,
                rangesHash,
            }

            return {
                usdQuotesByAges: this.quotesByAgesUSD,
                copQuotesByAges: this.quotesByAgesCOP,
            }
        },

        _filterEmptyClients(quotesByAges, quoteType) {
            for (let clientName in quotesByAges) {
                const clientRanges = quotesByAges[clientName].ranges
                const hasQuotes = clientRanges.some(
                    range => range[quoteType].length > 0
                )

                if (!hasQuotes) {
                    delete quotesByAges[clientName]
                }
            }
            return quotesByAges
        },
        // Charts
        createUsdPieChart() {
            const data = this.quotesByAgesHeaders
                .slice(1, -1)
                .map((header, index) => {
                    const total = this.getTotalsByRangeUsd(header.text)
                    return {
                        name: header.text,
                        y: total,
                        color: this.getColorByIndex(index),
                    }
                })
            this.chartUsdQuotesByAges = {
                chart: {
                    type: 'pie',
                },
                title: {
                    text: 'Total quotes by ages (USD)',
                },
                series: [
                    {
                        name: 'Total Costs',
                        colorByPoint: true,
                        data: data,
                    },
                ],
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format:
                                '<b>{point.name}</b>: {point.percentage:.1f} %',
                        },
                    },
                },
            }
        },
        createCopPieChart() {
            const data = this.quotesByAgesHeaders
                .slice(1, -1)
                .map((header, index) => {
                    const total = this.getTotalsByRangeCop(header.text)
                    return {
                        name: header.text,
                        y: total,
                        color: this.getColorByIndex(index),
                    }
                })

            this.chartCopQuotesByAges = {
                chart: {
                    type: 'pie',
                },
                title: {
                    text: 'Total quotes by ages (COP)',
                },
                series: [
                    {
                        name: 'Total Costs',
                        colorByPoint: true,
                        data: data,
                    },
                ],
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format:
                                '<b>{point.name}</b>: {point.percentage:.1f} %',
                        },
                    },
                },
            }
        },
        getColorByIndex(index) {
            const colors = [
                '#23bf85',
                '#efbd21',
                '#f39c12',
                '#db4d42',
                '#3498db',
                '#8e44ad',
                '#2ecc71',
                '#e74c3c',
                '#f1c40f',
                '#e67e22',
                '#1abc9c',
                '#34495e',
            ]
            return colors[index % colors.length]
        },
        // Quotes Dialogs
        openUsdRangeDialog(clientName, formattedRange, headerRange) {
            // Crear clave única para el cache
            const cacheKey = `USD_${clientName}_${formattedRange}`

            // Verificar si tenemos datos en cache
            if (this.rangeDataCache[cacheKey]) {
                this.quotesCurrency = 'USD'
                this.selectedClientName = clientName
                this.headerRange = headerRange
                this.formattedRange = formattedRange
                this.quotesForSelectedRange = this.rangeDataCache[cacheKey]
                this.quotesDialog = true
                return
            }

            // Validar que los datos estén disponibles
            if (!this.quotesByAgesUSD || !this.quotesByAgesUSD[clientName]) {
                return
            }

            this.quotesCurrency = 'USD'
            this.selectedClientName = clientName
            this.headerRange = headerRange
            this.formattedRange = formattedRange

            // Buscar el rango con validación
            const clientData = this.quotesByAgesUSD[clientName]
            if (!clientData || !clientData.ranges) {
                this.quotesForSelectedRange = []
                return
            }

            const foundRange = clientData.ranges.find(
                r =>
                    r.startDate.toLocaleDateString() +
                        ' - ' +
                        r.endDate.toLocaleDateString() ===
                    formattedRange
            )

            if (foundRange && foundRange.usdQuotes) {
                this.quotesForSelectedRange = foundRange.usdQuotes
                // Guardar en cache
                this.rangeDataCache[cacheKey] = [...foundRange.usdQuotes]
            } else {
                this.quotesForSelectedRange = []
                // Guardar array vacío en cache para evitar búsquedas futuras
                this.rangeDataCache[cacheKey] = []
            }

            // Siempre abrir el diálogo, pero mostrar mensaje si no hay datos
            this.quotesDialog = true
        },
        openCopRangeDialog(clientName, formattedRange, headerRange) {
            // Crear clave única para el cache
            const cacheKey = `COP_${clientName}_${formattedRange}`

            // Verificar si tenemos datos en cache
            if (this.rangeDataCache[cacheKey]) {
                this.quotesCurrency = 'COP'
                this.selectedClientName = clientName
                this.headerRange = headerRange
                this.formattedRange = formattedRange
                this.quotesForSelectedRange = this.rangeDataCache[cacheKey]
                this.quotesDialog = true
                return
            }

            // Validar que los datos estén disponibles
            if (!this.quotesByAgesCOP || !this.quotesByAgesCOP[clientName]) {
                return
            }

            this.quotesCurrency = 'COP'
            this.selectedClientName = clientName
            this.headerRange = headerRange
            this.formattedRange = formattedRange

            // Buscar el rango con validación
            const clientData = this.quotesByAgesCOP[clientName]
            if (!clientData || !clientData.ranges) {
                this.quotesForSelectedRange = []
                return
            }

            const foundRange = clientData.ranges.find(
                r =>
                    r.startDate.toLocaleDateString() +
                        ' - ' +
                        r.endDate.toLocaleDateString() ===
                    formattedRange
            )

            if (foundRange && foundRange.copQuotes) {
                this.quotesForSelectedRange = foundRange.copQuotes
                // Guardar en cache
                this.rangeDataCache[cacheKey] = [...foundRange.copQuotes]
            } else {
                this.quotesForSelectedRange = []
                // Guardar array vacío en cache para evitar búsquedas futuras
                this.rangeDataCache[cacheKey] = []
            }

            // Siempre abrir el diálogo, pero mostrar mensaje si no hay datos
            this.quotesDialog = true
        },
        closeDialog() {
            this.quotesDialog = false
            this.quotesForSelectedRange = []
            this.selectedClientName = null
            this.headerRange = ''
            this.formattedRange = ''
            this.quotesCurrency = ''
        },
        async openQuote(quote, costs) {
            if (this.settings.length > 0) {
                this.cardQuote = _.cloneDeep(quote)
                if (this.cardQuote.archive) {
                    this.cardQuote.attached = this.cardQuote.files.filter(
                        x => x.attach == true
                    )
                    this.cardQuote.docs = this.cardQuote.files.filter(
                        x => x.attach == false
                    )
                    this.cardQuote.sequence =
                        this.cardQuote.createdOn._seconds ||
                        this.cardQuote.createdOn.seconds
                    if (!this.cardQuote.number) {
                        this.cardQuote.shortId = (
                            this.cardQuote.createdOn._seconds ||
                            this.cardQuote.createdOn.seconds
                        )
                            .toString(16)
                            .toUpperCase()
                    }
                    this.cardQuote.date = moment
                        .unix(
                            this.cardQuote.createdOn._seconds ||
                                this.cardQuote.createdOn.seconds
                        )
                        .format('MMM/DD/YYYY')
                    this.cardQuote.createdOn = moment
                        .unix(
                            this.cardQuote.createdOn._seconds ||
                                this.cardQuote.createdOn.seconds
                        )
                        .format('MMM/DD/YYYY h:mm a')
                    this.cardQuote.updatedOn = moment
                        .unix(
                            this.cardQuote.updatedOn._seconds ||
                                this.cardQuote.updatedOn.seconds
                        )
                        .format('MMM/DD/YYYY h:mm a')
                }
                this.costs = costs
                await this.getHistoryCosts()
                this.setFromMainBoardAction(true)
                this.dialogQuote = true
            }
        },
        getHistoryCosts: async function() {
            try {
                this.loading = true
                this.error = false
                this.errorMsg = null
                const {
                    data: { historyCosts },
                } = await API.getHistoryCosts(this.cardQuote.id)
                if (historyCosts.length > 0) {
                    historyCosts.forEach(cost => {
                        cost.createdOn = moment
                            .unix(cost.createdOn._seconds)
                            .format('MMM/DD/YYYY h:mm a')
                    })

                    this.addHistoryCostAction({
                        idQuote: this.cardQuote.id,
                        historyCosts: historyCosts,
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        backToQuotesByAges() {
            this.dialogQuote = false
            this.setFromMainBoardAction(false)
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                followUpHeader: { clientHeight: headerHeight },
            } = this.$refs
            this.height = containerHeight - headerHeight + 19
            this.heightPopUp = window.innerHeight - 62
        },
    },
}
</script>

<style scoped>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead th {
    background-color: #eeeeee !important;
}
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.item_class {
    background-color: #3385d7 !important;
    color: white !important;
}
.quotes-table >>> .v-data-table__wrapper {
    max-height: 53vh;
    overflow-y: auto;
}
.quotes-table >>> .v-data-table__row {
    height: 64px;
}
.quotes-table >>> .v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
.ranges-table >>> .v-data-table__wrapper {
    max-height: 44vh;
    overflow-y: auto;
}
.ranges-table >>> .v-data-table__row {
    height: 64px;
}
.ranges-table >>> .v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
</style>
